import { mdiFormatListBulleted } from '@mdi/js'
import PPSelect from 'components/PPSelect'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getQueuePostAction, setQueuePostAction } from 'services/compose'
import Icon from '@mdi/react'
import styles from './QueuePostsActionSelect.pcss'

export function QueuePostsActionSelect({ disabled, className }: { disabled?: boolean, className?: string }) {
  const value: string = useSelector(getQueuePostAction)
  const dispatch = useDispatch()

  const onChange = (value: 'top' | 'bottom') => {
    dispatch(setQueuePostAction(value))
  }

  return (
    <PPSelect
      selectedValue={value}
      options={{
        top: { label: 'Top of Queue' },
        bottom: { label: 'Bottom of Queue' }
      }}
      className={`${styles.select} ${className || ''}`}
      buttonClassName={styles.btn}
      disabled={disabled}
      icon={<Icon path={mdiFormatListBulleted} size="20px" />}
      withCaret
      caretClassName={styles.caret}
      onSelectionChange={onChange}
    />
  )
}
